import { Link } from "gatsby";
import React from "react";
import Wrapper from "../structure/Wrapper";

export default function StepProgress(props) {
    const state = props.state || {application: '', components: []}
    const step = props.step;

    return (
        <Wrapper>
            <ol className="w-full flex justify-between mb-10 md:mb-14 rounded-full shadow-lg overflow-hidden bg-white text-primary">
                <li className={`p-4 flex-grow text-center text-xl leading-none rounded-full ${step === 1 ? 'block bg-primary text-white' : 'hidden md:block'}`}><Link to="/" state={state}>Wybierz swoją aplikację</Link></li>
                <li className={`p-4 flex-grow text-center text-xl leading-none rounded-full ${step === 2 ? 'block bg-primary text-white' : 'hidden md:block'}`}><Link to="/oczyscic" state={state}>Wybierz komponenty</Link></li>
                <li className={`p-4 flex-grow text-center text-xl leading-none rounded-full ${step === 3 ? 'block bg-primary text-white' : 'hidden md:block'}`}><Link to="/znajdowac" state={state}>Znajdź produkt</Link></li>
            </ol>
        </Wrapper>
    )
}